/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "styled-components"
import {
  theme,
  CssBaselineStyle,
  NotificationProvider,
} from "@omnichannel/ace-b2b-elements"
import Header from "./header"
import styled from "styled-components"
import Footer from "./footer"
import ActiveBranchProvider from "../context/activeBranch"
import CookiePolicy from "./cookiePolicy"
import useWebviewChecker from "./useWebviewChecker"

const Main = styled.div`
  display: flex;
  flex-direction: column;
`

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: ${props => props.minHeight ? props.minHeight : "100vh"};
  align-items: flex-start;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#F1F1F1"};
`

const FooterBox = styled.div`
  position: relative;
  width: 100%;
`

const Layout = ({
  showHeader = true,
  showFooter = true,
  location = {},
  children,
  backgroundColor,
  cartPop = {},
  hideCartPop,
  minHeight,
  performAuthCheck = true
}) => {
  const isWebview = useWebviewChecker()
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ThemeProvider theme={theme}>
      <ActiveBranchProvider>
        <CssBaselineStyle />
        {/* <FB /> */}
        <Main>
          <NotificationProvider>
            {showHeader && !isWebview && (
              <Header
                siteTitle={data.site.siteMetadata.title}
                location={location}
                cartPop={cartPop}
                hideCartPop={hideCartPop}
                performAuthCheck={performAuthCheck}
              />
            )}
            <Content minHeight={minHeight} backgroundColor={backgroundColor}>{children}</Content>

            {showFooter && !isWebview && (
              <FooterBox>
                <Footer />
              </FooterBox>
            )}
          </NotificationProvider>
        </Main>
      </ActiveBranchProvider>
      {!isWebview && <CookiePolicy />}
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
